import React from 'react';
import { useTranslation } from "react-i18next";

import { makeStyles } from "@material-ui/styles";
// eslint-disable-next-line
import Accordion from '@material-ui/core/Accordion';
// eslint-disable-next-line
import AccordionSummary from '@material-ui/core/AccordionSummary';
// eslint-disable-next-line 
import AccordionDetails from '@material-ui/core/AccordionDetails';
// eslint-disable-next-line
import Typography from '@material-ui/core/Typography';
// eslint-disable-next-line 
import { fade, Grid, Icon } from "@material-ui/core";
// eslint-disable-next-line 
import Card from "@material-ui/core/Card";
// eslint-disable-next-line 
import CardHeader from "@material-ui/core/CardHeader";
// eslint-disable-next-line 
import CardContent from "@material-ui/core/CardContent";
// eslint-disable-next-line 
import Divider from "@material-ui/core/Divider";

import ObjectsDrawer from './ObjectsDrawer'

const useStyles = makeStyles((theme) => ({
    AccordionRoot: {
        border: `1px solid ${fade(theme.palette.primary.main, 0.125)}`,
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        }
    },
    expanded: {},
    AccordionSummaryRoot: {
        backgroundColor: fade(theme.palette.primary.main, 0.0675),
        borderBottom: `1px solid ${fade(theme.palette.primary.main, 0.125)}`,
        marginBottom: -1,
        minHeight: '32px!important',
        '&$expanded': {
            minHeight: 32,
        }
    },
    AccordionSummaryContent: {
        margin: `${theme.spacing(1, 0)}!important`,
    },
    AccordionSummaryContentExpanded: {
        margin: theme.spacing(0, 0),
    },
    AccordionSummaryTitle: {
        fontSize: '0.8rem',
        fontWeight: theme.typography.fontWeightMedium
    },
    AccordionSummaryExpandIcon:{
        transform:'rotate(0deg)!important',
        marginRight:'0!important'
    },
    AccordionDetailsRoot: {
        padding: theme.spacing(2),
    },
    card: {
        height: '100%'
    },
    cardHeaderRoot: {
        backgroundColor: fade(theme.palette.primary.main, 0.00675),
        padding: theme.spacing(1, 1, 0, 2)
    },
    cardContent: {
        padding: theme.spacing(0, 1, 2, 2),

    },
    cardHeaderTitle: {
        fontSize: '0.8rem',
        fontWeight: theme.typography.fontWeightMedium
    }
}))

const ObjectsAccordion = ({ id_obiektu, cechyobiektu, onExpand }) => {
    // eslint-disable-next-line
    const { t } = useTranslation();
    // eslint-disable-next-line
    const classes = useStyles();
    // eslint-disable-next-line
    const [expanded, setExpanded] = React.useState('panel1');

    // eslint-disable-next-line
    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    return (
        <div>
            <ObjectsDrawer id_obiektu={id_obiektu} cechyobiektu={cechyobiektu} />
            {/* <Accordion
                square
                expanded={expanded === `obiekt-${id_obiektu}`}
                onChange={handleChange(`obiekt-${id_obiektu}`)}
                classes={{ root: classes.AccordionRoot }}
            >
                <AccordionSummary
                    aria-controls={`obiekt-${id_obiektu}-content`}
                    id={`obiekt-${id_obiektu}-header`}
                    expandIcon={cechyobiektu.length ? <ObjectsDrawer id_obiektu={id_obiektu} cechyobiektu={cechyobiektu} /> : null}

                    classes={{ 
                        root: classes.AccordionSummaryRoot, 
                        content: classes.AccordionSummaryContent, 
                        expanded: classes.AccordionSummaryContentExpanded,
                        expandIcon: classes.AccordionSummaryExpandIcon
                    }}
                    style={{cursor:'default'}}
                >
                    <Typography className={classes.AccordionSummaryTitle}>
                        {t('obiekt.cechy')}
                        <small>({cechyobiektu.length})</small>:
                    </Typography>
                </AccordionSummary>
            </Accordion> */}
        </div>
    );
}

export default ObjectsAccordion
